<template>
  <div>
    <figure class="image is-16by9">
      <screen
        :idx="screenId"
        :forceOfferId="offerId"
        :forceTemplateId="templateId"
        :forceScreens="screens"
      />
    </figure>
  </div>
</template>

<script>
import Screen from "./screen"

export default {
  name: "screen-preview",
  props: ["screenId", "offerId", "templateId", "screens"],
  components: { Screen }
}
</script>
